<template>
    <div id="tab3" class="content easein broadcast" :class="{ 'easein-active': opacitys }">
        <div class="split-title easein" :class="{ 'easein-active': opacitys }">
            <div class="line"></div>
            {{ desc.drama.configName }}
            <div class="line"></div>
        </div>
        <div class="split-desc easein" :class="{ 'easein-active': opacitys }">
            {{ desc.drama.configContent }}
        </div>
        <div class="broadcast-banner">
            <swiper :options="broadcastSwiperOptions">
                <swiper-slide class="broadcast-item-container" v-for="(items, index) in dramas" :key="index">
                    <a :href="items.audioUrl" target="_blank" class="broadcast-item">
                        <el-image :src="items.dramaImg" />
                    </a>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Broadcast',
    props: {
        opacitys: {
            type: Boolean,
            default: false,
        },
        dramas: {
            type: Array,
            default: () => [],
        },
        desc: {
            type: Object,
            default: () => {
                return {
                    drama: {
                        configName: '',
                        configContent: '',
                    },
                }
            },
        },
    },
    data: function () {
        return {
            broadcastSwiperOptions: {
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
        }
    },
}
</script>

<style lang="scss">
.broadcast {
    width: 1600px;
    margin: 0 auto;
    .broadcast-banner {
        // position: relative;
        width: 1426px;
        margin: 0 auto;
        margin-top: 60px;
        padding: 0 80px;
        box-sizing: border-box;
        .broadcast-item {
            width: 422px;
            height: 422px;
            position: relative;
            cursor: pointer;
            .el-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .swiper-button-prev,
        .swiper-button-next {
            width: 87px;
            height: 87px;
        }
    }
}
</style>
